<template>
  <div class="role-user-bd">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item v-if="funcView.role_user_bind || !!orgId">
          <el-button icon="el-icon-plus" @click="onAddBind" type="primary">
            <span>{{ $t('Common.com_add') }}</span>
          </el-button>
        </el-form-item>
        <el-form-item v-if="funcView.role_user_unbind || !!orgId">
          <el-button type="primary" icon="el-icon-minus" @click="cancelBind('all')" :disabled="tableSelect.length === 0">
            <span>{{ $t('base_role_user.yi_chu') }}</span>
          </el-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input :placeholder="$t('base_role_user.qsrgjc')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table type="checkbox" tableCode="roleUser" v-model="tableSelect" :data="userList" @column="setColumn" @filter="filterChange" @sort="sortChange" height="100%">
        <el-table-column :label="$t('Common.com_handle')" min-width="80" fixed="right" v-if="funcView.role_user_unbind || !!orgId">
          <template slot-scope="scope">
            <el-button @click="cancelBind(scope.row)" type="text" size="mini">{{ $t('base_role_user.yi_chu') }}</el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <role-user-add v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getRoleUserPage"></role-user-add>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import roleUserAdd from './role_user_add_dialog.vue';

export default {
  components: { roleUserAdd },
  props: {
    roleId: {
      type: [String, Number],
      default: '',
    },
    orgId: [String, Number],
  },
  data() {
    return {
      tableSelect: [],
      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,
        orgId: '',
        isAssociated: 1,
        roleId: '',
      },
      userList: [],
      totalRows: 0,
      isLoading: false,

      dialogVisible: false,
      dialogModel: {},
    };
  },
  watch: {
    roleId: function () {
      this.getRoleUserPage();
    },
  },
  mounted() {
    this.getFuncView('/company/role');
    this.getRoleUserPage();
  },
  methods: {
    // 获取用户列表
    getRoleUserPage: function () {
      if (!this.roleId) {
        return;
      }
      this.formSearch.roleId = this.roleId;
      this.formSearch.orgId = this.orgId;
      this.isLoading = true;
      this.$getJSON(apis.RoleUserPage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.userList = res.data.list;
        this.totalRows = Number.parseInt(res.data.total, 10);
      });
    },
    // 取消关联
    cancelBind: function (data) {
      const tips = data === 'all' ? this.$t('base_role_user.nqdyycxzdyhm') : this.$t('base_role_user.nqdyycxzdyhm');
      this.$showConfirm(tips)
        .then(() => {
          if (data === 'all') {
            this.onCancelBind(this.tableSelect);
          } else {
            this.onCancelBind([data]);
          }
        })
        .catch(() => {});
    },
    //  提交取消关联
    onCancelBind: function (data) {
      const param = data.map(t => ({
        bizId: t.userId,
        bizName: t.userName,
        bizType: 3,
      }));
      this.$postJSON(apis.RoleUserUnbind, {
        roleId: this.roleId,
        bizInfos: param,
      }).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.getRoleUserPage();
      });
    },
    // 新增
    onAddBind: function () {
      this.dialogModel.title = this.$t('base_role_user.xzygdgw');
      this.dialogModel.data = { roleId: this.roleId, orgId: this.orgId };
      this.dialogVisible = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getRoleUserPage();
    },
  },
};
</script>

<style lang="scss">
.role-user-bd {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 16px;
}
</style>
